/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ct_Order_NowInputs */

const en_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order Now`)
};

const ar_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلب الآن`)
};

const bn_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনই অর্ডার করুন`)
};

const de_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt bestellen`)
};

const es_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar ahora`)
};

const fr_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandez maintenant`)
};

const pt_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encomende agora`)
};

const zh_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即订购`)
};

const tr_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Sipariş Ver`)
};

const ru_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказать сейчас`)
};

const pl_ct_order_now = /** @type {(inputs: Ct_Order_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamów teraz`)
};

/**
* | output |
* | --- |
* | "Order Now" |
*
* @param {Ct_Order_NowInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_order_now = /** @type {((inputs?: Ct_Order_NowInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_Order_NowInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_order_now(inputs)
	if (locale === "bn") return bn_ct_order_now(inputs)
	if (locale === "de") return de_ct_order_now(inputs)
	if (locale === "es") return es_ct_order_now(inputs)
	if (locale === "fr") return fr_ct_order_now(inputs)
	if (locale === "pt") return pt_ct_order_now(inputs)
	if (locale === "zh") return zh_ct_order_now(inputs)
	if (locale === "tr") return tr_ct_order_now(inputs)
	if (locale === "ru") return ru_ct_order_now(inputs)
	if (locale === "pl") return pl_ct_order_now(inputs)
	return en_ct_order_now(inputs)
});